import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const RatePage = lazy(() => import('../pages/rate/page'));
const Top10Page = lazy(() => import('../pages/top10/page'));
const Top5UsersPage = lazy(() => import('../pages/top5users/page'));
const CharacterPage = lazy(() => import('../pages/character/page'));
const SeriesPage = lazy(() => import('../pages/series/page'));
const AllSeriesPage = lazy(() => import('../pages/all-series/page'));
const ProfilePage = lazy(() => import('../pages/profile/page'));
const FavoritesPage = lazy(() => import('../pages/favorites/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const AdminCommentsPage = lazy(() => import('../pages/admin-comments/page'));
const ResetPasswordPage = lazy(() => import('../pages/reset-password/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const FAQPage = lazy(() => import('../pages/faq/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/rate',
    element: <RatePage />,
  },
  {
    path: '/top10',
    element: <Top10Page />,
  },
  {
    path: '/top5users',
    element: <Top5UsersPage />,
  },
  {
    path: '/character/:slug',
    element: <CharacterPage />,
  },
  {
    path: '/series/:name',
    element: <SeriesPage />,
  },
  {
    path: '/series',
    element: <AllSeriesPage />,
  },
  {
    path: '/profile/:id',
    element: <ProfilePage />,
  },
  {
    path: '/favorites',
    element: <FavoritesPage />,
  },
  {
    path: '/admin',
    element: <AdminPage />,
  },
  {
    path: '/admin/comments',
    element: <AdminCommentsPage />,
  },
  {
    path: '/reset-password',
    element: <ResetPasswordPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/faq',
    element: <FAQPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
